import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Video, 
  Droplets, 
  Lock, 
  Wifi, 
  Newspaper, 
  BatteryCharging, 
  Utensils, 
  Puzzle, 
  BookOpen,
  ArrowLeft
} from 'lucide-react';
import './About.css'; // We will define these styles below

// 1. Data Array mapping directly from your Kotlin FacilityData
const facilities = [
  { name: "CCTV Security", icon: Video },
  { name: "RO Water", icon: Droplets },
  { name: "Private Lockers", icon: Lock },
  { name: "High-Speed WiFi", icon: Wifi },
  { name: "Newspapers", icon: Newspaper },
  { name: "Desk Charging", icon: BatteryCharging },
  { name: "Lunch Area", icon: Utensils },
  { name: "Relax Zone", icon: Puzzle, secondaryIcon: BookOpen } // Two icons, just like Android
];

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-screen">
      {/* Back Button Overlay */}
      <button className="back-button" onClick={() => navigate(-1)}>
        <ArrowLeft size={24} />
      </button>

      {/* -------- HEADER SECTION -------- */}
      <div className="about-header">
        <div className="header-content">
          <div className="logo-container">
            {/* Make sure your logo is in the public/assets folder */}
            <img src="/assets/logo.png" alt="Library Logo" className="logo" />
          </div>
          <h1 className="brand-title">Utkarsh Abhyasika</h1>
          <p className="brand-subtitle">A Space to Focus. A Place to Grow.</p>
        </div>
      </div>

      {/* -------- CONTENT BODY -------- */}
      <div className="about-body">
        
        <div className="info-card">
          <p>
            We provide a peaceful, disciplined, and focused study environment for serious aspirants. Experience modern amenities designed to maximize your concentration.
          </p>
        </div>

        <div className="section-divider">
          <span className="line"></span>
          <span className="divider-text">PREMIUM FACILITIES</span>
          <span className="line"></span>
        </div>

        {/* Grid Layout (Replaces chunked(2) Row/Column logic) */}
        <div className="facilities-grid">
          {facilities.map((item, index) => {
            const Icon1 = item.icon;
            const Icon2 = item.secondaryIcon;

            return (
              <div key={index} className="facility-card">
                <div className="icon-row">
                  <Icon1 size={32} className="facility-icon" />
                  {Icon2 && <Icon2 size={32} className="facility-icon secondary-icon" />}
                </div>
                <span className="facility-name">{item.name}</span>
              </div>
            );
          })}
        </div>

        {/* -------- FOOTER LINKS -------- */}
        <div className="footer-links">
          <span onClick={() => navigate('/legal')}>Privacy Policy</span>
          <span className="dot">•</span>
          <span onClick={() => navigate('/legal')}>Terms & Conditions</span>
        </div>
        
        <div className="version-text">Version 1.0.0</div>
      </div>
    </div>
  );
};

export default About;